import type { ReactNode } from 'react';
import {
  PortalFloatingShell,
  type PortalFloatingNavItem,
} from './PortalFloatingShell';

export type ItFloatingNavItem = PortalFloatingNavItem;

type ItFloatingShellProps = {
  items: ItFloatingNavItem[];
  pageTitle?: string;
  topExtra?: ReactNode;
  notifications?: ReactNode;
  mobileNotifications?: ReactNode;
  children: ReactNode;
};

/** IT Management floating chrome — thin wrapper around PortalFloatingShell. */
export function ItFloatingShell({
  items,
  pageTitle,
  topExtra,
  notifications,
  mobileNotifications,
  children,
}: ItFloatingShellProps) {
  return (
    <PortalFloatingShell
      portalName="IT Management"
      portalKind="it"
      items={items}
      pageTitle={pageTitle}
      topExtra={topExtra}
      notifications={notifications}
      mobileNotifications={mobileNotifications}
      topClassName="dem-theme-lab__top--it"
    >
      {children}
    </PortalFloatingShell>
  );
}
